export enum WebViewPostMessageType {
  NAVIGATE = 'navigate',
  LOGIN_AUTHENTICATED = 'login-authenticated',
  LOGOUT = 'logout',
  APP_MOUNTED = 'app-mounted',
  PAGE_LOAD_FINISHED = 'page-load-finished',
  REGISTER_NOTIFICATION_TOKEN = 'register-notification-token',
  REQUEST_NOTIFICATION_TOKEN = 'request-notification-token',
  REDIRECT_FINISHED = 'redirect-finished',
  NFE_PDF_CLICKED = 'nfe-pdf-clicked',
  CHECK_CAMERA_PERMISSION = 'check_camera-permission',
  CHECK_CAMERA_AVALABILITY = 'check-camera-availability',
  CAMERA_PERMISSION_RESULT = 'camera-permission-result',
}

export type WebViewMessage<T> = {
  type: WebViewPostMessageType
  data: T
}

export enum WebViewLocalStorage {
  TINO_IS_WEBVIEW = 'tinoIsWebview',
}

export enum WebViewParams {
  IS_TINO_WEBVIEW = 'apptino',
}
